export default __webpack_public_path__ + "static/jundroo-2c317c4990f0adebaac5b7787286d8bd.png";